import LegalDocPage from '@/components/LegalDocPage';

const CommunityGuidelines = () => <LegalDocPage documentType="community_guidelines" title="Community Guidelines" />;

export default CommunityGuidelines;
